import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * DivisionTeam Schema
 * Represents a team within a specific division (season/contest context)
 */

export const DivisionTeamSchema = z.object({
  _id: objectId,
  name: z.string().default(''),
  active: z.boolean().default(true),
  seed: z.number().min(-1).max(9999999).optional(),
  info: z.any().optional(), // Mixed type for flexible data
  // Refs
  team: objectId,
  division: objectId,
  league: objectId,
  organization: objectId,
  registrationTeam: objectId,
  registration: objectId,
  ...timestampFields,
});

export type DivisionTeam = z.infer<typeof DivisionTeamSchema>;

// Metadata for DivisionTeam fields (for Mongoose refs and UI)
export const divisionTeamMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  name: { label: 'Team Name', editable: true },
  active: { label: 'Active', editable: true },
  seed: { label: 'Seed', editable: true },
  info: { label: 'Info', hidden: true },
  team: { ref: 'Team', label: 'Team' },
  division: { ref: 'Division', label: 'Division' },
  league: { ref: 'League', label: 'League' },
  organization: { ref: 'Organization', hidden: true },
  registrationTeam: { ref: 'RegistrationTeam', label: 'Registration Team' },
  registration: { ref: 'Registration', label: 'Registration' },
  created: { hidden: true },
  updated: { hidden: true },
};
